import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const usePaypalOptions = isSubscribe => {
  const paypalMerchantId = useSelector(state => state.clientdata.paypalMerchantId);
  const paypalClientId = useSelector(state => state.clientdata.paypalClientId);

  return useMemo(() => {
    if (!paypalMerchantId || !paypalClientId) return undefined;
    return {
      'client-id': paypalClientId,
      'disable-funding': 'credit,card',
      locale: 'en_US',
      'merchant-id': paypalMerchantId,
      intent: isSubscribe ? 'subscription' : 'capture',
      vault: isSubscribe ? 'true' : 'false',
    };
  }, [paypalMerchantId, paypalClientId, isSubscribe]);
};
